import p1 from "@/assets/img/netword/p1.jpg";
import p2 from "@/assets/img/netword/p2.jpg";
import p3 from "@/assets/img/netword/p3.jpg";
import p4 from "@/assets/img/netword/p4.jpg";
import p5 from "@/assets/img/netword/p5.jpg";
import p6 from "@/assets/img/netword/p6.jpg";
import p7 from "@/assets/img/netword/p7.jpg";
import p8 from "@/assets/img/netword/p8.jpg";
import logo1 from "@/assets/img/netword/logo1.png";
import logo2 from "@/assets/img/netword/logo2.png";
import logo3 from "@/assets/img/netword/logo3.png";
import logo4 from "@/assets/img/netword/logo4.png";
import logo5 from "@/assets/img/netword/logo5.png";
import logo6 from "@/assets/img/netword/logo6.png";
import logo7 from "@/assets/img/netword/logo7.png";
import logo8 from "@/assets/img/netword/logo8.png";
import logos1 from "@/assets/img/netword/logo-s-1.png";
import logos2 from "@/assets/img/netword/logo-s-2.png";
import logos3 from "@/assets/img/netword/logo-s-3.png";
import logos4 from "@/assets/img/netword/logo-s-4.png";
import logos5 from "@/assets/img/netword/logo-s-5.png";
import logos6 from "@/assets/img/netword/logo-s-6.png";
import logos7 from "@/assets/img/netword/logo-s-7.png";
import logos8 from "@/assets/img/netword/logo-s-8.png";
import lg0 from "@/assets/img/netword/lg0.png";
import lg1 from "@/assets/img/netword/lg1.png";
import lg2 from "@/assets/img/netword/lg2.png";
import lg3 from "@/assets/img/netword/lg3.png";
import lg4 from "@/assets/img/netword/lg4.png";
import lg5 from "@/assets/img/netword/lg5.png";
import lg6 from "@/assets/img/netword/lg6.png";
import lg7 from "@/assets/img/netword/lg7.png";
import lg8 from "@/assets/img/netword/lg8.png";
import lg9 from "@/assets/img/netword/lg9.png";
import lg10 from "@/assets/img/netword/lg10.png";
import lg11 from "@/assets/img/netword/lg11.png";
import lg12 from "@/assets/img/netword/lg12.png";
import lg13 from "@/assets/img/netword/lg13.png";
import lg14 from "@/assets/img/netword/lg14.png";
import lg15 from "@/assets/img/netword/lg15.png";
import list01 from "@/assets/img/netword/list01.png";
import list02 from "@/assets/img/netword/list02.png";
import list03 from "@/assets/img/netword/list03.png";
import list04 from "@/assets/img/netword/list04.png";
import list05 from "@/assets/img/netword/list05.png";
import list06 from "@/assets/img/netword/list06.png";
import list07 from "@/assets/img/netword/list07.png";

export const popleData: NetWordPhotoData[][] = [
  [
    {
      id: 1,
      name: "Yiming Zhang",
      logo: logo1,
      logo2: logos1,
      founder: "Founder & cEO",
      img: p1,
      title: "Our Story",
      content: [
        "In 2015, we saw beyond ByteDance's news app to the AI powerhouse beneath. Backing Yiming's vision, we invested four times, supporting ByteDance from its early days to its ascension as a $10B+ decacorn.",
        "Today, as ByteDance reshapes global tech, our ongoing dialogue with Yiming keeps us ahead of the curve.",
      ],
    },
    {
      id: 5,
      name: "Chuan Wang",
      logo: logo5,
      logo2: logos5,
      founder: "COFounder & cSO",
      img: p5,
      title: "Our Story",
      content: [
        "As a co-founder of Xiaomi, Chuan Wang's visionary leadership and entrepreneurial experience have been instrumental in the company's success. He spearheaded the development of key products like the Xiaomi Box and Xiaomi TV, redefining smart home entertainment and enriching Xiaomi's ecosystem.",
        "Today, thanks to the efforts of Chuan and other co-founders, Xiaomi has transformed from a smartphone company into a global leader in consumer electronics and smart devices. Chuan continues to drive innovation, contributing significantly to product development and company strategy. His deep understanding of user experience and keen insight into technology trends keep Xiaomi at the forefront of the tech industry.", 
        "Our collaboration with Chuan extends beyond Xiaomi, encompassing investment decisions, company valuations, and post-investment management, exemplifying the synergy and value creation within our network."
],
    },
  ],
  [
    {
      id: 2,
      name: "William Li",
      logo: logo2,
      logo2: logos2,
      founder: "Founder & cEO",
      img: p2,
      title: "Our Story",
      content: [
        "We first met William in 2011 when he expressed his desire to create real value despite market pressures. His entrepreneurial spirit resonated deeply with us, leading to our investment in NIO in 2018.",
        "In 2019, amidst severe financial challenges and negative press, William’s unwavering commitment and innovative vision inspired us to support NIO further. By connecting NIO with government and societal funds, we helped secure critical support. ",
        "Today, NIO not only survived but thrived, redefining China's automotive industry on a global stage.  ",
      ],
    },
    {
      id: 3,
      name: "Xing Wang",
      logo: logo3,
      logo2: logos3,
      founder: "Founder & cEO",
      img: p3,
      title: "Our Story",
      content: [
        "Xing Wang impressed us with his engineer-like precision and philosophical approach. By 2016, despite market turbulence, we saw Meituan’s unwavering commitment to winning in the local services market, a sector critical to their strategy but secondary to competitors like Alibaba. This conviction led us to invest $130 million, encouraging other major investments. By 2018, Meituan’s successful IPO marked one of our most rewarding investments.",
      ],
    },
  ],

  [
    {
      id: 4,
      name: "Bin Xiao",
      logo: logo4,
      logo2: logos4,
      founder: "Founder & cEO",
      img: p4,
      title: "Our Story",
      content: [
        "In 2016, when Kingsoft Cloud’s revenue was a modest $30- 45M and China’s cloud sector was in its infancy, we saw a future giant. Our conviction led us to lead two investment rounds, becoming their largest external shareholder pre-IPO. ",
        "Our bond with Bin Xiao, strengthened by shared perseverance, was evident when Bin remarked, “Cynthia (FutureX founder) saw in my eyes something that few could understand.”",
        "Kingsoft Cloud’s successful NASDAQ listing and its rise as a top three public cloud provider in China validate our strategic foresight and commitment to transformative technology.",
      ],
    },
    {
      id: 8,
      name: "Art Wong",
      logo: logo8,
      logo2: logos8,
      founder: "Managing Partner",
      img: p8,
      title: "Our Story",
      content: ["Art Wong is a seasoned executive with extensive experience in cybersecurity, technology, and venture capital. Currently serving as the Managing Partner at Atherton Linden Capital Partners in the San Francisco Bay Area, Art has a diverse background that spans leadership roles in both established corporations and startups. His career highlights include serving as the Chief Executive Officer at Trustwave and holding the position of Chief Executive Officer for Global Cyber Security at Singtel. Art's expertise in security is further evidenced by his role as Senior Vice President and GM of Security at DXC Technology. With a strong foundation in technology and a growing focus on sustainable investments, as shown by his time as Operating Partner at Sustainable Opportunities Acquisition Corp., Art brings a wealth of knowledge to the venture capital space. He holds a degree from the University of Calgary and has furthered his education with the Stanford Executive Program at Stanford University Graduate School of Business."],
    },
  ],
  [
    {
      id: 6,
      name: "Cui Yi",
      logo: logo6,
      logo2: logos6,
      founder: "Founder & cEO",
      img: p6,
      title: "Our Story",
      content: ["Yi Cui is a distinguished Professor at Stanford University, where he has been leading a cutting-edge research lab since September 2005. With over 19 years of experience in academia, Professor Cui has established himself as a pioneering figure in the fields of materials science and nanotechnology. His research spans a wide range of interdisciplinary areas, focusing on innovative applications of nanotechnology. Professor Cui's work encompasses energy-related research, including advanced battery technologies and solar cells, as well as groundbreaking studies in electrochemistry and electrocatalysis. He is particularly renowned for his contributions to the development of transparent electrodes and 2D layered materials. Professor Cui's lab also delves into environmental technologies, working on solutions for water and air filtration, and solid waste clean-up. Additionally, his research extends to emerging fields such as wearable technology and nanobiotechnology, showcasing the breadth and impact of his scientific pursuits. With a strong educational background, including a degree from the University of Science and Technology of China and further studies at Harvard University, Professor Cui brings a wealth of knowledge and international perspective to his research. His work at Stanford continues to push the boundaries of materials science and nanotechnology, with potential applications that could significantly impact various aspects of technology and environmental sustainability."],
    },
    {
      id: 7,
      name: "Fengmin Gong",
      logo: logo7,
      logo2: logos7,
      founder: "CHairman",
      img: p7,
      title: "Our Story",
      content: ["Fengmin Gong is a renowned technology leader and serial entrepreneur with over two decades of experience in cybersecurity and artificial intelligence. Currently, he serves as CEO and Co-Founder of Metafoodx, an AI-powered food waste prevention solution enhancing foodservice profitability and sustainability. Gong's illustrious career includes co-founding Palo Alto Networks in 2006, where he pioneered next-generation firewall technologies. He has held key positions such as Chief Security Content Officer at FireEye and Chief Scientist at Huawei Symantec JV, driving innovation in anti-malware intelligence and security product development. His entrepreneurial spirit led him to co-found multiple successful ventures, including Cyphort Inc. and AssureSec Inc., both focused on advanced security solutions. Gong's expertise extends to large-scale operations, evident in his role as VP of InfoSec Strategy at Didi Chuxing and Head of DiDi Labs. Beyond his corporate achievements, Gong is actively involved in community leadership as the Chairman of HYSTA, working to empower Asian American professionals in technology and business. Fengmin Gong's career is marked by strategic vision, technical prowess, and a commitment to creating secure and productive digital ecosystems, continuously shaping the landscape of cybersecurity and AI-driven solutions."],
    },
  ],
];

export const logoList = [
  lg0,
  lg1,
  lg2,
  lg3,
  lg4,
  lg5,
  lg6,
  lg7,
  lg8,
  lg9,
  lg10,
  lg11,
  lg12,
  lg13,
  lg14,
  lg15,
];

export const cultivating: NetWordListItem[] = [
  {
    id: 1,
    title: "Seminars and Expert Sessions",
    content:
      "In 2023 alone, we hosted 30+ events, engaging more than 1,000 participants in cutting-edge discussions and knowledge sharing.",
    img: list01,
  },
  {
    id: 2,
    title: "Global Tech Tours",
    content:
      "We invite LPs and founders to join us on curated tours to regions like the Middle East, Silicon Valley, Southeast Asia, and China. These journeys offer firsthand exploration of diverse markets and refresh our collective frontline knowledge.",
    img: list02,
  },
  {
    id: 3,
    title: "Annual General Meetings",
    content:
      "Every 1-2 years, we convene to discuss trends and shape the future of technology and investment.",
    img: list03,
  },
  {
    id: 4,
    title: "Quarterly FutureX Dinners",
    content:
      "Held in major hubs like Beijing, Hong Kong, Singapore, and Silicon Valley, these gatherings foster collaboration among founders, industry experts, and investors.",
    img: list04,
  },
];

export const business: NetWordListItem[] = [
  {
    id: 1,
    title: "Charity Initiatives",
    content:
      "Since 2018, FutureX has been committed to supporting charitable foundations such as Adream. In addition to our own donations, we engage 10-20 investors annually in charitable events and organize impactful community activities.",
    img: list05,
  },
  {
    id: 2,
    title: "Life Academy",
    content:
      'We embrace the "Manual of Living" principles, fostering qualities of love, care, and forgiveness. Since 2016, we\'ve introduced over 100 founders and colleagues to Life Academy courses, with our team volunteering 20+ hours annually to support this initiative.',
    img: list06,
  },
  {
    id: 3,
    title: "Holistic Health Practices",
    content:
      "We offer a range of health programs that nurture both body and mind, from traditional Bigu practices promoting detoxification and self-discovery to innovative Tongue Acupuncture treatments. These initiatives support our network members in achieving a balanced lifestyle that enhances both professional and personal growth.",
    img: list07,
  },
];
